//
import ProviderModel from "@/models/Purchase/PchProvider"
import OrdererPriorityModel from "@/models/Warehouse/WhOrdererPriority"
import UserModel from "@/models/General/GUser"
import WarehouseModel from "@/models/Warehouse/WhWarehouse"

//
export default [
    {
        name: "wh_orderer.pch_provider_id",
        props: {
            itemText: "rut",
            itemValue: "id",
            label: "Rut",
            model: ProviderModel,
            noObject: true,
            paramSearch: "search",
        },
        type: "autocomplete-model",
        value: [],
    },
    {
        name: "wh_orderer.pch_provider_id",
        props: {
            itemText: "alias_name",
            itemValue: "id",
            label: "Proveedor",
            model: ProviderModel,
            noObject: true,
            paramSearch: "search",
        },
        type: "autocomplete-model",
        value: [],
    },
    {
        name: "wh_orderer.wh_orderer_priority_id",
        props: {
            itemText: "priority",
            itemValue: "id",
            label: "Prioridad",
            model: OrdererPriorityModel,
            noAsyncSearch: true,
            noObject: true,
            paramSearch: "search",
        },
        type: "autocomplete-model",
        value: [],
    },
    {
        name: "wh_orderer.g_supervisor_user_id",
        props: {
            itemText: "full_name",
            itemValue: "id",
            label: "Responsable",
            model: UserModel,
            noObject: true,
            paramSearch: "search",
        },
        type: "autocomplete-model",
        value: [],
    },
    {
        name: "wh_orderer.wh_warehouse_id",
        props: {
            itemText: "name",
            itemValue: "id",
            label: "Bodega",
            model: WarehouseModel,
            noObject: true,
            paramSearch: "search",
        },
        type: "autocomplete-model",
        value: [],
    },
]